import { useEffect, useState } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useToast, usePopup, useTheme, useStore, useGrid, useModal } from "@/comn/hooks";
import {
    BASE,
    APIS,
    SCHEMA_FORM_COMN_CD_SRCH,
    SCHEMA_GRID_COMN_CD,
    SG_COMM_CD_EXCEL_FORM,
} from "./services/ComnCdService";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

export const CommonCodeList = (props: any) => {
    const pgeUid = "comnCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const [load, setLoad] = useState(false);
    const params = props.params;

    const { theme } = useTheme();

    const form = {
        comnCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_COMN_CD_SRCH,
            defaultValues:
                // { ...pgeStore?.form, comnCd: params?.comnCd || "", langCd: theme.lang.toUpperCase() || "" } || {},
                {
                    comnCd: params?.comnCd || "",
                    cdVldVal: params?.cdVldVal || "",
                    langCd: theme.lang.toUpperCase() || "",
                },
        }),
    };

    const grid = {
        comnCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_COMN_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        comnCdExcelLst: useGrid({
            defaultSchema: SG_COMM_CD_EXCEL_FORM,
        }),
    };

    const fetch = {
        getComnCdLst: useFetch({
            api: (page = grid.comnCdLst.page) => {
                return APIS.getComnCdLst(form.comnCdSrch.getValues(), page, grid.comnCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.comnCdSrch.errors) && form.comnCdSrch.isSubmitted,
            key: [grid.comnCdLst.page, grid.comnCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.comnCdSrch.getValues(),
                    page: grid.comnCdLst.page,
                    size: grid.comnCdLst.size,
                });
            },
        }),
        getComnCdExcelLst: useFetch({
            api: (data: any) => (load ? APIS.getComnCdExcelLst(data) : null),
            enabled: comnUtils.isEmpty(form.comnCdSrch.errors),
            onSuccess: () => {
                if (load) {
                    grid.comnCdExcelLst.exportExcel({
                        // Internal Portal Customs User Information !== 내부 포털_세관_사용자 정보 ==!
                        excelName: `${t("T_COMN_CD_LST")}__${dayjs().format("DD/MM/YYYY HHmm")}`,
                        sheetName: "Sheet1",
                    });
                }
                setLoad(false);
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.comnCdSrch.handleSubmit(
                () => {
                    grid.comnCdLst.setPage(0);
                    fetch.getComnCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.comnCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_ComnCdLst: {
            cell: {
                cdVldVal: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: rowValues.cdVldVal, label: rowValues.cdVldValNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        if (params?.comnCd) {
            form.comnCdSrch.setSchema("comnCd", { readOnly: true });
        }
        if (params?.cdVldVal) {
            form.comnCdSrch.setSchema("cdVldVal", { readOnly: true });
        }
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.comnCdLst.setOption("checkbox", true);
        }

        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) || load) {
            fetch.getComnCdExcelLst.fetch(store.form);
        }
    }, [load]);

    return (
        <Page title={t("T_COMN_CD_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.comnCdSrch.schema.comnCd}></Group.Control>
                                <Group.Control {...form.comnCdSrch.schema.cdVldVal}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.comnCdSrch.schema.cdVldValNm}></Group.Control>
                                <Group.Control {...form.comnCdSrch.schema.langCd} select={true}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role={"reset"}
                                    onClick={() => {
                                        form.comnCdSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="excelDown"
                                    onClick={() => {
                                        setLoad(true);
                                    }}
                                ></Button>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.comnCdLst.grid}
                            data={fetch.getComnCdLst.data?.comnCdList}
                            render={render.grid_ComnCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group hidden>
                <Grid {...grid.comnCdExcelLst.grid} data={fetch.getComnCdExcelLst.data?.comnCdExcelList} />
            </Group>
        </Page>
    );
};
